const ReviewSignSectionHeader = ({
  toggleForm = () => {},
  id = "",
  headerText = "",
}) => {
  return (
    <div className="row">
      <div className="col-9" id={`${id}-heading`}>
        <h4>{headerText}</h4>
      </div>
      <div className="col-3" id={`${id}-edit`}>
        <button
          className="btn btn-link"
          style={{ float: "right" }}
          onClick={toggleForm}
        >
          Edit
        </button>
      </div>
    </div>
  );
};
export default ReviewSignSectionHeader;
